<form  class="row g-3 p-2 border border-dark border-1 p-2 mt-3 rounded" (ngSubmit)="onGetCompenseTrx()"
  [formGroup]="compenseForm">

  <div class="form-floating col">
    <input type="date" class="form-control" placeholder="Date de d&#233;part" id="startDate" formControlName ="startDate">
    <label for="startDate" class="form-label">Date de d&#233;part</label>
  </div>
  <div class="form-floating col">

    <input type="date" class="form-control mr-4" id="endDate" placeholder="Date de fin" formControlName="endDate" name="endDate">
    <label for="endDate" class="form-label">Date de fin</label>
  </div>
  <div class="col ">
    <label class="form-label"></label>
    <button type="submit" class="btn btn-success mt-2 w-100">Valider</button>
  </div>
</form>
<div class="btn border border-1 border-dark mt-2 mb-2 p-2 rounded">
  <i class="fa fa-file-excel-o btn mr-2" (click)="exportToExcel()" style="color: green;" aria-hidden="false">Excel</i>
  <span class="ml-4"></span>
</div>
<div id="listTransaction" class="row">


  <table class="table table-bordered table-hover table-striped text-center" id="tableTrx">
    <thead class="table-success">
      <tr>
        <th class="col">Date</th>
        <th class="col">Montant</th>
        <th class="col">Commission</th>
        <th class="col">Moyen Paiement</th>
        <th class="col">Commission Operateur</th>
        <th class="col">Etablissement</th>
        <th class="col">Commission versus</th>
      </tr>
    </thead>
    <tbody>
      @for (trx of transactions?.content | paginate : pageConfig; track trx) {
        <tr>
          <td>{{trx.paymentDate}}</td>
          <td>{{trx.requestAmount}}</td>
          <td>{{trx.commission}}</td>
          <td>{{trx.bank.name}}</td>
          <td>{{trx.partPaymentMeans}}</td>
          <td>{{trx.merchant.name}}</td>
          <td>{{trx.partVersus}}</td>
        </tr>
      }
    </tbody>
    <div class="d-flex justify-content-center">
      <pagination-controls
        previousLabel="Precedent"
        nextLabel="Suivant"
        (pageChange)="onNextPage($event)">
      </pagination-controls>
    </div>
  </table>
</div>